<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item>
                    <el-select
                      v-model="form.origin"
                      placeholder="仓库"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in storehouseIds"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.shipping_company"
                      placeholder="快递公司"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="item in conditionData.shipping_company"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.type"
                      placeholder="类型"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="(item, index) in conditionData.pici_type"
                        v-if="item != ''"
                        :key="index"
                        :label="item"
                        :value="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.status"
                      placeholder="状态"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="(item, index) in conditionData.pici_status"
                        :key="index"
                        :label="item"
                        :value="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="提交时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="审核时间：" style="width: 500px">
                    <el-date-picker
                      v-model="form.check_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="primary"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="cod_pici_no"
              label="审核批次"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cod_pici_origin"
              label="仓库"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_admin_name"
              label="提交人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="提交时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="提交说明"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="shipping_company"
              label="快递公司"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="包裹数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_num"
              label="商品件数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cod_pici_type"
              label="类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="money"
              label="应收货款"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cod_pici_status"
              label="状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="check_admin_name"
              label="审核人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="check_time"
              label="审核时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="money_time"
              label="收款日期"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="check_reason"
              label="审核理由"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == 1"
                  type="text"
                  size="small"
                  @click="
                    checkVisible = true;
                    check_id = scope.row.cod_pici_id;
                  "
                  >审核</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
        <el-dialog title="类型" :visible.sync="checkVisible" width="380">
          <el-form style="margin-left: 10%">
            <el-form-item>
              <template>
                <el-radio v-model="check_status" label="2">通过</el-radio>
                <el-radio v-model="check_status" label="3">驳回</el-radio>
              </template>
            </el-form-item>
            <el-form-item label="收款时间：" style="width: 500px">
              <el-date-picker
                v-model="money_time"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="审核理由">
              <el-input
                v-model="check_reason"
                type="textarea"
                placeholder="审核理由"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="checkVisible = false">取 消</el-button>
              <el-button type="primary" @click="check">确 定</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.el-table .stock-row {
  background: #f7fd7b;
}
</style>
<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
    });
  },
  data() {
    return {
      resData: [],
      conditionData: {
        shipping_company: [],
      },
      cityData: {},
      districtData: {},
      is_show_search_option: 0,
      search_type: "wave_picking_no",
      search_options: [
        { key: "wave_picking_no", name: "波次号" },
        { key: "shipping_num", name: "快递单号" },
        { key: "user_id", name: "用户id" },
        { key: "consignee", name: "收件人姓名" },
      ],
      search_value: "",
      form: {
        // check_time:this.defaultDate(),
        create_time: this.defaultDate(),
        multipleSelection: [],
        shipping_company: "",
        status: "",
        pagesize: 100,
      },
      origin_list: [
        {
          origin_id: 1,
          origin_name: "广州",
        },
        {
          origin_id: 2,
          origin_name: "杭州",
        },
      ],
      storehouseIds: [],
      show_log_time: 0,
      loading: false,
      url: "/erp/cod/checkList",
      origin: 1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      wave_num: 0,
      shipping_company: "",
      checkVisible: false,
      mark_type: 0,
      can_sub: 1,
      check_id: 0,
      check_status: 1,
      money_time: "",
      check_reason: "",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    check() {
      this.$http
        .post("/erp/cod/check", {
          id: this.check_id,
          check_reason: this.check_reason,
          money_time: this.money_time,
          check_status: this.check_status,
        })
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.checkVisible = false;
            this.$message.success(res.data.msg);
            this.fetchData();
          }
        });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 24:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;
      this.fetchData(true);
    },
    selectOrigin(key) {
      this.form.origin = this.origin = key;
      // this.loading = true;
      // this.$http.post(this.url, this.filteredForm).then(res => {
      //     setTimeout(() => {
      //         this.loading = false;
      //     }, 200);
      //     if (res.data.code !== 200) {
      //         this.$message.error(res.data.msg);
      //         this.resData = res.data.data;
      //     } else {
      //         this.resData = res.data.data;
      //     }
      // });
    },

    fetchCondition() {
      this.$http.post("/erp/cod/condition").then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.conditionData = res.data.data;
          this.origin = res.data.data.origin;
        }
      });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }

      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    resetCondition() {
      this.form = {
        is_remark: 0,
        out_time: this.defaultDate(),
        create_time: this.searchDate(),
        province: [],
        city: [],
        district: [],
      };
      this.search_value = "";
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/cod/checkList.vue